import z from "zod";
import type {
    OrderPayRequestCancelledEvent} from "./order-pay-request-cancelled.event";
import {
    isOrderPayRequestCancelledEvent,
    orderPayRequestCancelledEventZodObject,
} from "./order-pay-request-cancelled.event";
import type {
    OrderPayRequestExpiredEvent} from "./order-pay-request-expired.event";
import {
    isOrderPayRequestExpiredEvent,
    orderPayRequestExpiredEventZodObject,
} from "./order-pay-request-expired.event";
import type {
    OrderPayRequestFulfilledEvent} from "./order-pay-request-fulfilled.event";
import {
    isOrderPayRequestFulfilledEvent,
    orderPayRequestFulfilledEventZodObject,
} from "./order-pay-request-fulfilled.event";
import type {
    OrderPayRequestPendingEvent} from "./order-pay-request-pending.event";
import {
    isOrderPayRequestPendingEvent,
    orderPayRequestPendingEventZodObject,
} from "./order-pay-request-pending.event";

type OrderPayRequestEvent =
    | OrderPayRequestExpiredEvent
    | OrderPayRequestCancelledEvent
    | OrderPayRequestFulfilledEvent
    | OrderPayRequestPendingEvent;

const orderPayRequestEventZodDiscriminatedUnion = z.discriminatedUnion("type", [
    orderPayRequestExpiredEventZodObject,
    orderPayRequestCancelledEventZodObject,
    orderPayRequestFulfilledEventZodObject,
    orderPayRequestPendingEventZodObject,
]);

const orderPayRequestEventZodSchema: z.ZodSchema<OrderPayRequestEvent> =
    orderPayRequestEventZodDiscriminatedUnion;

const isOrderPayRequestEvent = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any
): event is OrderPayRequestEvent => {
    return (
        isOrderPayRequestExpiredEvent(event) ||
        isOrderPayRequestCancelledEvent(event) ||
        isOrderPayRequestFulfilledEvent(event) ||
        isOrderPayRequestPendingEvent(event)
    );
};

export {
    orderPayRequestEventZodDiscriminatedUnion,
    orderPayRequestEventZodSchema,
    isOrderPayRequestEvent,
};
export type { OrderPayRequestEvent };
